
// UTILS FUNCTIONS

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
  }
function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
          preventDefault(e);
          return false;
      }
  }

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
        document.addEventListener('wheel', preventDefault, {passive: false}); // Disable scrolling in Chrome
        window.addEventListener("keydown", arrow_keys_handler, false);
        document.querySelector('html').classList.add('overflow');
        document.querySelector('body').classList.add('overflow');
  }

  function enableScroll() {
      if (window.removeEventListener)
          window.removeEventListener('DOMMouseScroll', preventDefault, false);
      document.removeEventListener('wheel', preventDefault, {passive: false}); // Enable scrolling in Chrome
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
      window.removeEventListener("keydown", arrow_keys_handler, false);
      document.querySelector('html').classList.remove('overflow');
      document.querySelector('body').classList.remove('overflow');
  }

  var arrow_keys_handler = function(e) {
    switch(e.keyCode){
      case 37: case 39: case 38:  case 40: // Arrow keys
      case 32: e.preventDefault(); break; // Space
      default: break; // do not block other keys
    }
  };


function getOffsetTop(element) {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

function randomIntFromRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function randomColor(colors) {
  return colors[Math.floor(Math.random() * colors.length)]
}

function distance(x1, y1, x2, y2) {
  const xDist = x2 - x1
  const yDist = y2 - y1

  return Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2))
}

module.exports = { disableScroll, enableScroll, getOffsetTop, randomIntFromRange, randomColor, distance }

// utils.disableScroll(); 

document.addEventListener('DOMContentLoaded', function() {
 
    const footer = document.querySelector('footer .sec_hero');
    const container = footer.querySelector('.container');
    const rightElement = footer.querySelector('.right');
    const leftElement = footer.querySelector('.left');
    
    const startTranslateY = 90;
    const endTranslateYRight = -355;
    const endTranslateYLeft = -318;
    const endTranslateYContainer = -470;
    // const animationSpeedFactor = 0.5;
    let ticking = false;
    let isLargeScreen = window.matchMedia("(min-width: 1041px)").matches;
    
    function easeOutQuad(t) {
        return t * (2 - t);
    }
    
    function updateElementPosition(element, endTranslateY) {
        const rect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top < windowHeight && rect.bottom > -windowHeight) {
            const scrollProgress = Math.min((windowHeight - rect.top) / windowHeight, 1.5);
            const eased = easeOutQuad(scrollProgress) ;
            const translateY = startTranslateY + (endTranslateY - startTranslateY) * eased;
            element.style.transform = `translateY(${translateY}px)`;
        }
    }
    
    function updatePositions() {
        if (isLargeScreen) {
            updateElementPosition(rightElement, endTranslateYRight);
            updateElementPosition(leftElement, endTranslateYLeft);
            container.style.transform = ''; // Reset container for large screens
        } else {
            updateElementPosition(container, endTranslateYContainer);
            rightElement.style.transform = ''; // Reset right element for small screens
            leftElement.style.transform = '';  // Reset left element for small screens
        }
        ticking = false;
    }
    
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updatePositions);
            ticking = true;
        }
    }
    
    function onResize() {
        const newIsLargeScreen = window.matchMedia("(min-width: 1041px)").matches;
        if (newIsLargeScreen !== isLargeScreen) {
            isLargeScreen = newIsLargeScreen;
            updatePositions();
        }
    }
    
    updatePositions();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);    


    const logo = document.querySelector('footer .nav .container .left');

    if (logo) {
        const logoListItem = document.createElement('li');
        logoListItem.classList.add('item', 'logo-item');
        const logoClone = logo.cloneNode(true);
        logoListItem.appendChild(logoClone);
        const navWrap = document.querySelector('.nav_wrap');
        if (navWrap) {
            navWrap.insertBefore(logoListItem, navWrap.firstChild);
        }
    } 
    

    function checkSlickDots() {
        const slickDotsList = document.querySelector('.sec_hero .slick-dots'); 
        if (slickDotsList) {
            const listItems = slickDotsList.querySelectorAll('li');
            if (listItems.length === 1) {
                slickDotsList.style.display = 'none';
            } else {
                slickDotsList.style.display = ''; 
            }
            observer.disconnect();
        }
    }
    const observer = new MutationObserver((mutationsList, observer) => {
        checkSlickDots();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
 
    
    function setEqualHeights(selector) {
        const postCardContents = document.querySelectorAll(selector);
    
        if (postCardContents.length > 0) { 
            let maxHeight = 0;
    
            postCardContents.forEach(content => { 
                content.style.height = 'auto'; 
                const contentHeight = content.offsetHeight;
                if (contentHeight > maxHeight) {
                    maxHeight = contentHeight;
                }
            });
    
            postCardContents.forEach(content => {
                content.style.height = `${maxHeight}px`;
            });
        } 
    }
    
    setEqualHeights('.oxo-view.template-home .sec_archive .cards_container.with_three_cols .cards_wrap .post_card .content');
    setEqualHeights('.oxo-view.template-archive.archive-qdn .archive .post-wrap .container .post-container .post_card .content');
    setEqualHeights('.oxo-view.template-single.post-qdn #cards .container .post_wrap .post_card .content');
    setEqualHeights('.oxo-view.template-single.post-qdn.post-offre .like .no_post_wrap_slider .post_card .content');
    
    window.addEventListener('resize', () => {
        setEqualHeights('.oxo-view.template-single.post-qdn.post-offre .like .no_post_wrap_slider .post_card .content');
        setEqualHeights('.oxo-view.template-single.post-qdn #cards .container .post_wrap .post_card .content');        
        setEqualHeights('.oxo-view.template-home .sec_archive .cards_container.with_three_cols .cards_wrap .post_card .content');
        setEqualHeights('.oxo-view.template-archive.archive-qdn .archive .post-wrap .container .post-container .post_card .content');
    });

    
    
    
    
    function initializeSlider() {
        if (window.innerWidth <= 1040) {
            const featuresWrap = document.querySelector('.with_two_cols .features_wrap');
            const featureCards = document.querySelectorAll('.with_two_cols .feature_card');
            const dots = document.querySelectorAll('.slider-dot');
    
            let currentIndex = 0;
    
            function updateSlide() {
                featureCards.forEach((card, index) => {
                    const offset = (index - currentIndex) * 100;
                    card.style.transform = `translateX(${offset}%)`;
                });
    
                // Update active dot
                dots.forEach((dot, index) => {
                    dot.classList.toggle('active', index === currentIndex);
                });
            }
    
            // Add click event to each dot
            dots.forEach(dot => {
                dot.addEventListener('click', () => {
                    currentIndex = parseInt(dot.getAttribute('data-index'));
                    updateSlide();
                });
            });
    
            // Initialize the position of the slides
            updateSlide();
        }
    }
    
    // Run slider initialization on load and resize
    window.addEventListener('load', initializeSlider);
    window.addEventListener('resize', initializeSlider);

    
     
    

});
